export default __webpack_public_path__ + "assets/images/e230e58c0d66079e4d64f3448f3c8249.svg";